import request from '/src/config/request.js'

// 获取系统配置
export const apiConfig = data => {
    return request({
        url: '/setup',
        method: 'post',
        data,
    })
}

// 获取图片验证的图片
export const apiDetail = data => {
    return request({
        url: '/infos',
        method: 'post',
        data,
    })
}
